import { ReactElement } from 'react'
import { useWatch } from 'react-hook-form'
import { ErrorFieldBase } from '@ui/forms'

const PrioritizationWarning = (): ReactElement | null => {
  const innerInner = useWatch({ name: 'inner_inner' }) as string[]
  const innerFoundation = useWatch({ name: 'inner_foundation' }) as string[]
  const outerOuter = useWatch({ name: 'outer_outer' }) as string[]
  const outerFoundation = useWatch({ name: 'outer_foundation' }) as string[]

  const hasEmptyPrioritization =
    !innerInner?.length ||
    !innerFoundation?.length ||
    !outerOuter?.length ||
    !outerFoundation?.length

  if (!hasEmptyPrioritization) return null

  const emptyPrioritizations: string[] = []
  if (!innerInner?.length) emptyPrioritizations.push('Innen-Innen')
  if (!innerFoundation?.length) emptyPrioritizations.push('Innen-Fundament')
  if (!outerOuter?.length) emptyPrioritizations.push('Außen-Außen')
  if (!outerFoundation?.length) emptyPrioritizations.push('Außen-Fundament')

  return (
    <ErrorFieldBase
      severity="error"
      message={`Bitte setzen Sie die Priorisierung für: ${emptyPrioritizations.join(', ')}`}
      data-cy="project-connection-prioritization-warning"
    />
  )
}

export default PrioritizationWarning
